export default __webpack_public_path__ + "static/media/orange_waves.bfef5ca4.svg";